import React, { useState } from "react";
import "./CategorySelector.css"; // Import the CSS file

// Define categories and links
const categories = {
  "MGNREGS": [
    { name: "Download Social Audit Report", url: "https://mnregaweb4.nic.in/NregaArch/SocialAudit/SA_LoginReport.aspx?id=24" },
    { name: "Category wise work Status of Balasore", url: "https://nregastrep.nic.in/netnrega/citizen_html/physicalperftemp_n.aspx?lflag=eng&district_code=2405&district_name=BALESHWAR&state_code=24&state_name=ODISHA&page=d&fin_year=2025-2026&Digest=Z60bnc7zQYKzewjN8BY/QQ" },
    { name: "Works completed since inception in MIS Balasore", url: "https://nregastrep.nic.in/netnrega/takenup_compwrk.aspx?lflag=eng&district_code=2405&district_name=BALESHWAR&state_code=24&state_name=ODISHA&page=d&fin_year=2025-2026&Digest=Z60bnc7zQYKzewjN8BY/QQ" },
    { name: "Employment Generated during the year 2025-2026", url: "https://nregastrep.nic.in/netnrega/citizen_html/demregister.aspx?state_code=24&state_name=ODISHA&district_code=2405&district_name=BALESHWAR&page=D&lflag=eng&fin_year=2025-2026&Digest=ImD/AqXU17m8I8Zk9elLlA" },
    { name: "Financial Performance 2025-2026", url: "https://nregastrep.nic.in/Netnrega/writereaddata/citizen_out/funddisreport_2405_eng_2526_.html" },
    { name: "GEO-MGNREGA ", url: "https://bhuvan-app2.nrsc.gov.in/mgnrega/nrega_dashboard_phase2/" },
    { name: "Search Work/eMR/ Job Card etc", url: "https://mnregaweb4.nic.in/netnrega/homesearch.htm" },
    { name: "FTO Status", url: "https://nregastrep.nic.in/netnrega/FTO/FTOReport.aspx?page=d&lflag=eng&state_code=24&state_name=ODISHA&fin_year=2025-2026&district_code=2405&district_name=BALESHWAR&typ=x&Digest=KEhYBkC6/++XrrXKKM+8pQ" },
    { name: " Employment Generated During The financial Year 2025-2026", url: "https://nregastrep.nic.in/netnrega/state_html/empstatusnewall_scst.aspx?state_code=24&state_name=ODISHA&district_code=2405&district_name=BALESHWAR&page=D&lflag=eng&fin_year=2025-2026&Digest=ImD/AqXU17m8I8Zk9elLlA" },
	
	


  
  ],
  "15th CFC REPORT": [
    { name: "Approved Action Plan", url: "https://egramswaraj.gov.in/planningDashBoard.do" },
    { name: "Financial Report", url: "https://egramswaraj.gov.in/financialProgressReport.do" },
  ],
  "PMAY-G": [
    { name: "Search Beneficiary through Registration Number", url: "https://rhreporting.nic.in/netiay/benificiary.aspx" },
    { name: "Social Audit Report for verification", url: "https://rhreporting.nic.in/netiay/SocialAuditReport/BeneficiaryDetailForSocialAuditReport.aspx" },
    { name: "Search Registration No & MGNREGS Work Code", url: "https://rhreporting.nic.in/netiay/ConvergenceReport/HouseSanctionedVsWorkCreatedReport.aspx" },
  ],
  "NSAP": [
    { name: "Beneficiary List", url: "https://nsap.nic.in/statedashboard.do?method=intialize" },
  ],
  "OTHERS": [
     ],
};

function CategorySelector() {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedLink, setSelectedLink] = useState("");

  // Handle category selection
  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
    setSelectedLink(""); // Reset selected link when category changes
  };

  // Handle link selection
  const handleLinkChange = (event) => {
    setSelectedLink(event.target.value);
  };

  // Handle form submit
  const handleSubmit = (event) => {
    event.preventDefault();
    if (selectedLink) {
      window.location.href = selectedLink;
    } else {
      alert("Please select a link to open.");
    }
  };

  return (
    <div className="category-container">
      <h2>Select a Category:</h2>
      <form onSubmit={handleSubmit}>
        {/* Category Dropdown */}
        <select onChange={handleCategoryChange} value={selectedCategory} className="select-box" required>
          <option value="" disabled>Select Category</option>
          {Object.keys(categories).map((category) => (
            <option key={category} value={category}>
              {category}
            </option>
          ))}
        </select>

        {/* Links Dropdown */}
        {selectedCategory && (
          <div style={{ marginTop: "20px" }}>
            <h3>{selectedCategory}:</h3>
            <select className="select-box" onChange={handleLinkChange} value={selectedLink} required>
              <option value="" disabled>Select Link</option>
              {categories[selectedCategory].map((link) => (
                <option key={link.name} value={link.url}>
                  {link.name}
                </option>
              ))}
            </select>
          </div>
        )}
        {/* Submit Button */}
        <button type="submit" className="submit-button">
          SUBMIT
        </button>
      </form>
    </div>
  );
}

export default CategorySelector;
